/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/form-data/lib/browser.js
// module id = 257
// module chunks = 27